import { normalizePath } from 'Simple/Flow'
import { useOnClick as useOnClickInternal } from '../../helpers.js'

export function useOnClick(props) {
  return useOnClickInternal({
    skipCleanup: true,
    viewPath: normalizePath(props.viewPath, '../..').replace(/\/$/, ''),
  })
}
